import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
interface BonusCardProps {
  number: number;
  title: string;
  value: number;
  description: string;
  delay?: number;
}
export function BonusCard({
  number,
  title,
  value,
  description,
  delay = 0
}: BonusCardProps) {
  return <motion.div className="bg-[var(--bg-card)] rounded-xl overflow-hidden border-2 border-[var(--accent-orange)]/30 hover:border-[var(--accent-orange)] transition-all duration-300" initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay,
    duration: 0.6
  }} data-id="element-9">
      <div className="bg-gradient-to-r from-[var(--accent-orange)] to-[var(--accent-orange-hover)] p-4" data-id="element-10">
        <div className="flex items-center gap-3" data-id="element-11">
          <GiftIcon className="w-6 h-6 text-white" aria-hidden="true" data-id="element-12" />
          <span className="text-lg font-bold text-white" data-id="element-13">BONO #{number}</span>
        </div>
      </div>

      <div className="p-6" data-id="element-14">
        <h3 className="text-xl md:text-2xl font-bold text-[var(--text-light)] mb-3" data-id="element-15">
          {title}
        </h3>
        <p className="text-2xl md:text-3xl font-black text-[var(--accent-orange)] mb-4" data-id="element-16">
          Valor Real: ${value} USD
        </p>
        <p className="text-lg text-[var(--text-gray)] mb-4" data-id="element-17">{description}</p>
        <div className="inline-block bg-[var(--accent-orange)]/20 px-4 py-2 rounded-lg" data-id="element-18">
          <p className="text-lg font-bold text-[var(--accent-orange-light)]" data-id="element-19">
            Tuyo GRATIS
          </p>
        </div>
      </div>
    </motion.div>;
}